import React from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { colors } from './colors';

// Crea el tema para styled-components
const theme = {
  colors,
};
const ThemeProvider = ({ children }) => {
  return (
    <StyledThemeProvider theme={theme}>
      {children}
    </StyledThemeProvider>
  );
};

export default ThemeProvider;

